import axios from "axios";
import { toast } from "react-toastify";

import { localStorageToken, localStorageUser, authStorage } from "./variables";

export const getError = (error) => {
  if (error.response?.data?.error) return error.response?.data?.error;
  else if (error.response?.data?.message) return error.response?.data?.message;
};

let renderedToast = null;

export const logout = async (history) => {
  renderedToast = toast.loading("Logging you out", {
    position: "top-center",
    autoClose: 3000,
  });
  try {
    const token = authStorage.getItem(localStorageToken);

    const res = await axios.post(
      `${process.env.REACT_APP_STORE_LOCATION_API}/api/v1/auth/singout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res?.status === 200) {
      authStorage.removeItem(localStorageToken);
      authStorage.removeItem(localStorageUser);
      toast.update(renderedToast, {
        render: "Log Out successful!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        hideProgressBar: false,
      });
      history.push("/login");
    }
  } catch (error) {
    toast.update(renderedToast, {
      render: getError(error),
      type: "error",
      isLoading: false,
      autoClose: 3000,
      hideProgressBar: false,
    });
  }
};

export const descriptionCharLimitClass = (value) => {
  let string = "";
  const length = value?.length;
  if (length > 0 && length < 20) string += "text-yellow-400";
  else if (length >= 20 && length < 250) string += "text-green-500";
  else if (length >= 250) string += "text-red-600";
  return string;
};

export const productDescriptionCharLimitClass = (value) => {
  let string = "";
  const length = value?.length;
  if (length > 0 && length < 20) string += "text-yellow-400";
  else if (length >= 20 && length < 1000) string += "text-green-500";
  else if (length >= 1000) string += "text-red-600";
  return string;
};
